import { createSlice } from '@reduxjs/toolkit';

const getInitialSnapshot = () => {
    const today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth(); // 0-based

    if (today.getDate() <= 7) {
        month = month === 0 ? 11 : month - 1;
        if (month === 11) year -= 1;
    }

    // Format as YYYY-MM-01
    const monthStr = String(month + 1).padStart(2, '0'); // +1 because getMonth is 0-based
    console.log(`${year}-${monthStr}-01`);
    return `${year}-${monthStr}-01`;
};


const savedSnapshot = localStorage.getItem('savedSnapshot');

const appSlice = createSlice({
    name: 'app',
    initialState: {
        snapshot: savedSnapshot || getInitialSnapshot(),
        partnerSummary: [],
        partnerSummarySnapshot: null,
        overviewStats: null,
        overviewStatsSnapshot: null,
        profileDcu: { cacheKey: null, data: [], total: 0, totalPages: 1 },
        profileCountries: { cacheKey: null, data: [] },
        profilePolicies: { cacheKey: null, data: [], total: 0, totalPages: 1 },
    },
    reducers: {
        setSnapshot: (state, action) => {
            state.snapshot = action.payload;
        },
        setPartnerSummary: (state, action) => {
            state.partnerSummary = action.payload.data;
            state.partnerSummarySnapshot = action.payload.snapshot;
        },
        setOverviewStats: (state, action) => {
            state.overviewStats = action.payload.data;
            state.overviewStatsSnapshot = action.payload.snapshot;
        },
        setProfileDcu: (state, action) => {
            state.profileDcu = action.payload;
        },
        setProfileCountries: (state, action) => {
            state.profileCountries = action.payload;
        },
        setProfilePolicies: (state, action) => {
            state.profilePolicies = action.payload;
        },
        updatePolicyDecision: (state, action) => {
            const { ppf_id, decision, decision_changed } = action.payload;
            const row = state.profilePolicies.data.find(r => r.ppf_id === ppf_id);
            if (row) {
                row.decision = decision;
                row.decision_changed = decision_changed;
            }
        },
    },
});

export const { setSnapshot, setPartnerSummary, setOverviewStats, setProfileDcu, setProfileCountries, setProfilePolicies, updatePolicyDecision } = appSlice.actions;
export default appSlice.reducer;